// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"9af6e49f","977":"fb897b07"}[chunkId] + ".chunk.js";
};